import { Navigate } from "react-router-dom";
import Layout from "./common/layout/Layout";
import EnrollVesselPage from "./pages/MyFleet/EnrollVessel/EnrollVesselPage";
import DashboardPage from "./pages/Dashboard/DashboardPage";
import EditVesselPage from "./pages/MyFleet/EditVessel/EditVesselPage";
import ReportsPage from "./pages/Reports/reports-page/reports-page";
import MyFleetPage from "./pages/MyFleet/MyFleetPage";
import PortCodesPage from "./pages/PortCodesPage/PortCodesPage";
import ReportDetailsPage from "./pages/Reports/ReportDetails/ReportDetailsPage";
import SeempPage from "./pages/SEEMP/SeempPage";
import VesselRevisionGridPage from "./pages/SEEMP/VesselRevisionGridPage/VesselRevisionGridPage";
import HelpPage from "./components/Help/Help";
import ManageAccountPage from "./components/ManageAccount/ManageAccount";
import AdminPage from "./components/AdminModule/Admin/Admin";
import ManageUserDetails from "./components/AdminModule/Admin/ManageUserDetails";
import CIICalculationPage from "./pages/CIICalculation/CIICalculationPage";
import EventLogsData from "./components/AdminModule/event-logs/eventLogs";
import NotificationSettings from "./components/NotificationSettings/NotificationSettings";
import CdpAuthPage from "./pages/Cdp/CdpAuth";
import FuelEUMonitoringForm from "./components/FuelEUMonitoring/FuelEUMonitoringForm";
import VideoTutorials from "./components/Help/VideoTutorials";
import Guides from "./components/Help/Guides";
import Resources from "./components/Help/Resources";
import Contacts from "./components/Help/Contacts";
import FuelMonitoringPlanTable from "./components/FuelEUMonitoring/FuelEuMonitoringTable";
import UnderMaintenance from "./components/UnderMaintenance/UnderMaintenance";
import ConfirmEmail from "./components/NotificationSettings/ConfirmEmail/ConfirmEmail";
import CompanyEmissionVerification from "./components/EuMrvCompanyEmissioneport/EuMrvCompanyEmissionsReport.js";
import EuMrvCompanyEmissionReport from "./components/EuMrvCompanyEmissioneport/EuMrvCompanyEmissionsReport.js";
import CERlisting from "./components/EuMrvCompanyEmissioneport/CERlisting/CERlistingpage.js";
import MrvMonitoringPlan from "./components/MonitoringPlans/Mrv/MrvMonitoringPlan";
import PlanVerificationDetailsPage from "./pages/PlanVerification/PlanVerificationDetails/PlanVerificationDetailsPage";
import PlanVerificationPage from "./pages/PlanVerification/PlanVerificationPage/PlanVerificationPage";
import SeempMonitoringPlanIII from "./components/MonitoringPlans/SEEMP/SeempIII/SeempMonitoringPlanIII";
import SeempMonitoringPlanII from "./components/MonitoringPlans/SEEMP/SeempII/SeempMonitoringPlanII";
import ExportEuMrvDataPage from "./pages/ExportData/ExportEuMrvDataPage";
import ExportDcsDataPage from "./pages/ExportData/ExportDcsDataPage";
import FuelEuMonitoringPlan from "./components/MonitoringPlans/FuelEu/FuelEumonitoring";
import FuelFormcontainer from "./components/VesselDetails/FuelregistryV2/FuelFormContainer";
import FuelRegistryForm from "./components/VesselDetails/FuelregistryV2/FuelRegistryForm";
import { FeatureType } from "./constants/FeatureToggles";
import { ClaimsContext } from "./services/ClaimsService";
import { useEffect, useState, useContext } from "react";
import BulkExportPage from "./components/AdminModule/Admin/BulkExport/BulkExportPage";
import UnsatisfactoryCIIRatingExportPage from "./components/AdminModule/Admin/UnsatisfactoryCIIRatingExport/UnsatisfactoryCIIRatingExportPage";
import CompanyEmissionReportPage from "./components/EuMrvCompanyEmissioneport/CompanyEmissionReportDetails/CompanyEmissionReportDetails.js";
import FEUComplianceBalanceReportsPage from "./components/ReportDetails/FEUComplianceBalanceReports/FEUComplianceBalanceReportsPage";
import FEUComplianceBalanceReportDetailsPage from "./components/ReportDetails/FEUComplianceBalanceReports/FEUComplianceBalanceReportDetailsPage";

const RootPageRedirect = () => {
	const {
		userHasFeature,
		userFeaturesAreLoaded,
		fetchUserFeatures,
	} = useContext(ClaimsContext);

	useEffect(() => {
		if (!userFeaturesAreLoaded) {
			fetchUserFeatures();
		}
	}, [userFeaturesAreLoaded, fetchUserFeatures]);

	// Wait until features are loaded
	if (!userFeaturesAreLoaded) {
		return null; // or <Loader />
	}

	const dashboardEnabled = userHasFeature(FeatureType.Dashboard);

	return (
		<Navigate
			to={dashboardEnabled ? "/dashboard" : "/my-fleet"}
			replace
		/>
	);
};

export const Routes = [
	{
		path: "/",
		element: <Layout />,

		children: [
			{
				path: "/",
				element: <RootPageRedirect />,
			},
			{
				path: "dashboard",
				element: <DashboardPage />,
			},
			{
				path: "cdpauth",
				element: <CdpAuthPage />,
			},
			{
				path: "my-fleet",
				element: <MyFleetPage />,
			},
			{
				path: "fuel-form",
				element: <FuelRegistryForm />,
			},
			{
				path: "confirmEmail",
				element: <ConfirmEmail />,
			},
			{
				path: "my-fleet/enroll-vessel",
				element: <EnrollVesselPage />,
			},
			{
				path: "my-fleet/:vesselMstId/mrv-monitoring-plan",
				element: <MrvMonitoringPlan />,
			},
			{
				path: "my-fleet/:vesselMstId/fueleu-monitoring-plan",
				element: <FuelEuMonitoringPlan />,
			},
			{
				path: "reports",
				element: <ReportsPage />,
			},
			{
				path: "fuel-monitoring-plan",
				element: <FuelMonitoringPlanTable />,
			},
			{
				path: "manage-user-details",
				element: <ManageUserDetails />,
			},
			{
				path: "reports/:id",
				element: <ReportDetailsPage />,
			},
			{
				path: "my-fleet/enroll-vessel/:vesselMstId",
				element: <EditVesselPage />,
			},
			{
				path: "port-codes",
				element: <PortCodesPage />,
			},
			{
				path: "eumrv-company-emission-verification-report",
				element: <EuMrvCompanyEmissionReport />,
			},
			{
				path: "cvr-listing",
				element: <CERlisting />,
			},
			{
				path: "fuel-monitoring-plan/form",
				element: <FuelEUMonitoringForm />,
			},
			{
				path: "cii-calculations",
				element: <CIICalculationPage />,
			},
			{
				path: "seemp",
				element: <SeempPage />,
			},
			{
				path: "my-fleet/:vesselMstId/seempiii-monitoring-plan",
				element: <SeempMonitoringPlanIII />

			},
			{
				path: "my-fleet/:vesselMstId/seempii-monitoring-plan",
				element: <SeempMonitoringPlanII />

			},
			{
				path: "seemp/vessel-revision-grid/:imoNumber",
				element: <VesselRevisionGridPage />,
			},
			{
				path: "support",
				element: <HelpPage />,
			},
			{
				path: "manage-account",
				element: <ManageAccountPage />,
			},
			{
				path: "notification-settings",
				element: <NotificationSettings />,
			},
			{
				path: "admin",
				element: <AdminPage />,
			},
			{
				path: "eventlogs",
				element: <EventLogsData />,
			},
			{
				path: "video-tutorials",
				element: <VideoTutorials />,
			},
			{
				path: "guides",
				element: <Guides />,
			},
			{
				path: "resources",
				element: <Resources />,
			},
			{
				path: "contacts",
				element: <Contacts />,
			},
			{
				path: "plan-verification",
				element: <PlanVerificationPage />,
			},
			{
				path: "plan-verification/:planId",
				element: <PlanVerificationDetailsPage />,
			},
			{
				path: "updatedfuelregistry",
				element: <FuelFormcontainer />,
			},
			{
				path: "export-eu-mrv-data",
				element: <ExportEuMrvDataPage />,
			},
			{
				path: "export-dcs-data",
				element: <ExportDcsDataPage />,
			},
			{
				path: "bulk-export",
				element: <BulkExportPage />,
			},
			{
				path: "unsatisfactory-cii-ratings-vessel-export",
				element: <UnsatisfactoryCIIRatingExportPage />,
      		},
      		{
				path: "eumrv-company-report-details",
				element: <CompanyEmissionReportPage/>,
			},
			{
				path: "company-verification-report/:companyVerificationReportId",
				element: <CompanyEmissionReportPage/>,
			},
			{
				path: "feu-compliance-balance-reports",
				element: <FEUComplianceBalanceReportsPage />,
			},
			{
				path: "feu-compliance-balance-reports/:id",
				element: <FEUComplianceBalanceReportDetailsPage />,
			},
		],
	},
];

export const UnderMaintenanceRoutes = [
	{
		path: "/",
		element: <UnderMaintenance />,
	},
	{
		path: "*",
		element: <UnderMaintenance />,
	},
];
